import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import authSlice from "../../store/auth/authSlice";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { OnboardingAxios, ProgramSetupAxios, UserActivityAxios } from "../../API";
import { useHistory } from "react-router";

import { useLocation } from "react-router-dom";
import store from "../../store/index";


const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const location = useLocation();
  const loggedInUser = useSelector((state) => state.auth.loggedInUser);
  const userTokenData = useSelector((state) => state.auth.tokenData);
  // if(!userTokenData || !userTokenData.account){
  //   sessionStorage.clear();
  //   localStorage.clear();
  //   window.location.href = window.location.origin;
  // }
  const [userEmail, setUserEmail] = useState(
    (userTokenData && userTokenData?.account && userTokenData?.account?.username) || ""
  );

  useEffect(() => {
    if (userTokenData && userTokenData?.account && userTokenData?.account?.username) {
      setUserEmail(userTokenData?.account?.username);
    }
  }, [userTokenData]);

  const [errorMsg, setErrorMsg] = useState("");
  const [offeringId, setOfferingId] = useState(4);
  const [offerings, setOfferings] = useState([]);
  const [defaultOffering, setDefaultOffering] = useState(0);
  const [selectedOffering, setSelectedOffering] = useState(null);
  const [teams, setTeams] = useState([]);
  const [defaultTeam, setDefaultTeam] = useState(1);
  const [selectedTeam, setSelectedTeam] = useState(null);

  const userLogin = () => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!userEmail || regex.test(userEmail) === false) {
      setErrorMsg("Please enter valid email.");
      return false;
    }

    if (userEmail === "admin@deloitte.com") {
      const user = { firstName: "Admin", lastName: "Admin", email: userEmail, roleId: 3, offeringId: 0, teamId: 1 };
      dispatch(authSlice.actions.setLoggedInUser(user));
      history.push("/admin/dashboard");
    }

    var tempTeamid = selectedTeam ? selectedTeam.id : 0;

    OnboardingAxios.get(
      "OfferingUsers/getofferinguserbyemail/" + offeringId + "/" + userEmail + "/" + tempTeamid
    )
      .then(function (response) {
        if (response.data !== "") {
          let userDetails = {
            ...response.data,
            offeringStartDate: selectedOffering.startDate,
            offeringEndDate: selectedOffering.endDate
          };
          dispatch(authSlice.actions.login(userDetails));
          setErrorMsg("");
          ProgramSetupAxios.get(
            "OfferingMission/getmissionbyid/" +
            response.data.missionId +
            "/" +
            response.data.offeringUserId
          )
            .then(function (missionReponse) {
              dispatch(
                authSlice.actions.setMissionDetails(missionReponse.data)
              );
              //OfferingPointType/getofferingpointtypes/14
              ProgramSetupAxios.get(
                "OfferingPointType/getofferingpointtypes/" +
                response.data.offeringId
              )
                .then(function (pointTypesReponse) {
                  dispatch(
                    authSlice.actions.setPointTypes(pointTypesReponse.data)
                  );
                  if (new Date(selectedOffering.startDate) < new Date()) {

                    history.push("/home");
                  }
                  else {
                    const user = { email: userEmail, offeringId: offeringId };
                    dispatch(authSlice.actions.setLoggedInUser(user));
                    history.push({
                      pathname: "/onboarding",
                      // state: { offeringId: offeringId, email: userEmail },
                    });
                  }
                  var UAdata = {
                    email: response.data.email,
                    offeringId: response.data.offeringId,
                    missionId: response.data.missionId,
                    userId: response.data.userId,
                    offeringUserId: response.data.offeringUserId,
                    actionType: "Onboarding",
                    actionName: "Login",
                    actionOn: "",
                  };
                  UserActivityAxios.post(`UserActivityLog`, UAdata).then(function (res) {

                  }).catch(function (error) {
                    console.log(error);
                  });
                })
                .catch(function (error) {
                  console.log(error);
                });
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          setErrorMsg(
            "You are not enrolled in the selected program offering. Please contact the Program Team if this is an error."
          );
          // history.push("/onboarding");
          const user = { email: userEmail, offeringId: offeringId };
          dispatch(authSlice.actions.setLoggedInUser(user));
          history.push({
            pathname: "/onboarding",
            // state: { offeringId: offeringId, email: userEmail },
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };


  useEffect(() => {
    if (loggedInUser && loggedInUser.offeringUserId)
      store.reset();
    // debugger;
    dispatch(authSlice.actions.setTokenData(JSON.parse(sessionStorage.getItem("cdx-token"))));
  }, []);
  var prefillledOfferinId = 0;
  var prefillledemail = "";
  var prefillledTeamId = 0;

  useEffect(() => {

    //dispatch(authSlice.actions.resetStore());
    const params = new URLSearchParams(window.location.search);
    let offeringIdParam = parseInt(params.get("offeringId"));
    console.log("OfferingId  :::: ", offeringIdParam);
    if (location.state) {
      prefillledOfferinId = location.state.offeringId;
      prefillledemail = location.state.email;
      prefillledTeamId = location.state.teamId;
    }
    if (prefillledOfferinId && prefillledemail && prefillledTeamId) { offeringIdParam = prefillledOfferinId; setUserEmail(prefillledemail); }

    ProgramSetupAxios.get("Offering/getallactiveofferings")
      .then(function (response) {
        let tempOfferingId = 0;
        if (response.data.length > 0) {
          if (offeringIdParam) {
            setDefaultOffering(offeringIdParam);
            tempOfferingId = offeringIdParam;
            setOfferingId(offeringIdParam);
            setSelectedOffering(
              response.data.filter((x) => x.id === offeringIdParam)[0]
            );
          } else {
            setDefaultOffering(response.data[0].id);
            tempOfferingId = response.data[0].id;
            setOfferingId(response.data[0].id);
            setSelectedOffering(
              response.data.filter((x) => x.id === response.data[0].id)[0]
            );
          }
        }
        setOfferings(response.data);

        //call api to get teams
        getTeams(tempOfferingId, userEmail ? userEmail : prefillledemail);

      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const getTeams = (offeringId, email) => {
    if (email != "" || email != undefined) {
      OnboardingAxios.get("Team/getuserteams/" + offeringId + "/" + email)
        .then(function (response) {
          if (response.data.length > 0) {
            dispatch(authSlice.actions.setUserTeams(response.data));
            setTeams(response.data);
            if (prefillledTeamId) {
              setDefaultTeam(response.data.find(x => x.id == prefillledTeamId).id);
              setSelectedTeam(response.data.find(x => x.id == prefillledTeamId));
            }
            else {
              setDefaultTeam(response.data[0].id);
              setSelectedTeam(response.data[0]);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const onProgramChange = (e) => {
    setOfferingId(e.target.value);
    setSelectedOffering(
      offerings.filter((x) => x.id === parseInt(e.target.value))[0]
    );
    getTeams(e.target.value, userEmail);
  };


  const onTeamChange = (e) => {
    setSelectedTeam(teams.find(x => x.id === parseInt(e.target.value)));
  };

  useEffect(() => {
    if (userTokenData && userTokenData?.account && userTokenData?.account?.username) {
      setUserEmail(userTokenData?.account?.username);
    }
  }, [userTokenData]);



  return (
    <>
      <div className="login-wrapper">
        <div className="logoBox"></div>
        <div className="login-box">
          <Form
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="text"
                placeholder="name@example.com"
                defaultValue={userEmail}
                onChange={(e) => setUserEmail(e.target.value.trim())}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Program Offering</Form.Label>
              <Form.Control
                as="select"
                defaultValue={defaultOffering}
                onChange={(e) => {
                  onProgramChange(e);
                }}
              >
                <option value="">Select</option>
                {offerings &&
                  offerings.map((offering, index) => {
                    return (
                      <option
                        key={`${offering.id}${index}`}
                        value={offering.id}
                        selected={offering.id === defaultOffering}
                      >
                        {offering.programName}
                      </option>
                    );
                  })}
              </Form.Control>
            </Form.Group>
            {teams.length > 1 &&

              <Form.Group>
                <Form.Label>Team</Form.Label>
                <Form.Control
                  as="select"
                  defaultValue={defaultTeam}
                  onChange={(e) => {
                    onTeamChange(e);
                  }}
                >
                  {teams && teams.length > 0 &&
                    teams.map((team, index) => {
                      return (
                        <option
                          key={`${team.id}${index}`}
                          value={team.id}
                          selected={team.id === defaultTeam}
                        >
                          {team.teamName}
                        </option>
                      );
                    })}
                </Form.Control>
                {/* <Form.Control type="phone" placeholder="offering id" required onChange={(e) => setOfferingId(e.target.value)} /> */}
              </Form.Group>
            }
            <div className="text-center">
              <Button variant="primary" type="submit" onClick={() => userLogin()}>
                Continue
              </Button>
            </div>
          </Form>
        </div>
        <div className="errorMsgText">{errorMsg}</div>
        <div style={{ position: "absolute", bottom: "25px", left: "25px", gap: "15px", display: "flex" }}>
          <a
            href="https://cookienotice.deloitte.com"
            target="_blank"
            rel="noreferrer"
          >
            Cookies
          </a>
          <a className="optanon-toggle-display">Cookie Settings</a>
        </div>
      </div>
    </>
  );
};

export default Login;
